import React, {ReactNode, useState} from 'react';
import {ArrowRight} from 'lucide-react';
import {Package} from 'lucide-react';
import {Gem} from 'lucide-react';
import {IconGrid} from "../components/icons/IconGrid";
import {Typography} from "../components/ui/Typography";
import {FilterSearchSortBar} from "../components/common/FilterSearchSortBar";
import {FeaturedIconPackGrid} from "../components/icons/FeaturedIconPackGrid";

export interface MetricCardData {
    title : string;
    amount : number;
    icon: ReactNode;
}

export const METRIC_DATA: MetricCardData[] = [
    {
        title: "Total Icons Owned",
        amount: 1248,
        icon: <ArrowRight />,
    },
    {
        title: "Collections Owned",
        amount: 6,
        icon: <Package/>,
    },
    {
        title: "Credits Remaining",
        amount: 23,
        icon: <Gem/>,
    },
];

export const Library = ( any) => {
    const [activeView, setActiveView] = useState("icons");
    return (
        <main className="flex-grow">
            <div id="library-header" className="max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-2">
                
                <Typography as="h1" variant="h1" className="text-surface-300">
                    Library
                </Typography>
                
                <Typography as="p" variant="p" className="text-lg py-8">
                    Welcome back, <span className="" >Bertje!</span>
                    <br />
                    Browse and download your purchased icons and packs.
                </Typography>
                
                {/*<div className="min-h-[160px] py-8 mb-8 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-6xl mx-auto">*/}
                {/*    {METRIC_DATA.map(pack => <MetricCard key={pack.title} data={pack}/>)}*/}
                {/*</div>*/}
                
            </div>

            <FilterSearchSortBar isActiveView={activeView} setActiveView={setActiveView}/>
            {activeView === 'icons' ? <IconGrid/> : <FeaturedIconPackGrid/>}
            {/*<IconGrid />*/}
            
        </main>
    );
};

export const MetricCard = ({data}: any) => {
    const {title, amount, icon} = data as MetricCardData;
    return (
        <div className="bg-surface-900 border border-surface-500 rounded-xl p-5 flex items-center gap-6">
            <div
                className="w-16 h-16 flex-shrink-0 bg-surface-900 rounded-lg flex 
                items-center justify-center text-brand-500">
                {icon}
            </div>
            <div>
                <div className="text-sm text-surface-300">
                    {title}
                </div>
                <div className="text-2xl font-bold font-heading text-surface-50">
                    <NumberFormatter value={amount}/>
                </div>
            </div>
        </div>
    );
};

export const SearchAndSortingBar = (any) => {
    return (
        <div className="sticky top-0 z-10 bg-[var(--bg-background)]/80 backdrop-blur-md 
        border-y border-[var(--border-color)]">
            <div className="max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8 py-4 flex 
            flex-col md:flex-row items-center gap-4">
                
                <LibrarySearch/>
                <SortingDropdown/>
                
            </div>
        </div>
    );
};

export const LibrarySearch = (any) => {
    return (
        <div className="relative w-full md:max-w-xs">
            <i data-lucide="search"
               className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-surface-300"></i>
            <input type="text" placeholder="Search your library..."
                   className="w-full bg-[var(--bg-surface)] border border-[var(--border-color)] 
                   text-sm rounded-lg pl-10 pr-4 py-2.5 focus:ring-2 focus:ring-brand-500 
                   focus:border-brand-500 outline-none transition-colors"/>
        </div>
    );
};

export const SortingDropdown = (any) => {
    return (
        <div className="flex items-center gap-2">
            <div className="relative">
                <select
                    className="custom-select appearance-none bg-[var(--bg-surface)] border 
                    border-[var(--border-color)] text-sm rounded-lg pl-3 pr-8 py-2.5 focus:ring-2 
                    focus:ring-brand-500 focus:border-brand-500 outline-none transition-colors">
                    <option>Alphabetical</option>
                    <option>Recently Added</option>
                </select>
                <i data-lucide="chevrons-up-down"
                   className="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 
                   text-surface-300 pointer-events-none"></i>
            </div>
        </div>
    );
};


const NumberFormatter: React.FC<{ value: number }> = ({value}) => {
    const formatted = new Intl.NumberFormat('en-US', {maximumSignificantDigits: 3}).format(value); 
    return <div>{formatted}</div>; 
};




